/* eslint-disable @typescript-eslint/no-require-imports */
import type RewardStore from '../../AppData/_stores/RewardStore'
import Coupon, { type CouponProps } from './Coupon'

const getRewardImageUrl = (slug: string) => {
  try {
    return require('@resources/img/account/rewards/rewards/' + slug + '.svg?url') as string;
  } catch {
    return undefined;
  }
}

interface Props extends Omit<CouponProps, 'img' | 'htmlText'> {
  reward: RewardStore
}

export default function UserRewardCoupon(props: Props) {
  const { reward, ...otherProps } = props;
  const imageUrl = getRewardImageUrl(reward.get('slug'));

  if (imageUrl === undefined) {
    return null;
  }

  return <Coupon
    img={imageUrl}
    htmlText={reward.get('name')}
    {...otherProps}
  />
}
